<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        (exportar)="onExportar($event)"
        [data]="insuranceData"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'comisiones'"
      [camposVisibles]="['tipoDoc', 'cortePeriodo']"
      [camposObligatorios]="['tipoDoc', 'cortePeriodo']"
      (filterChange)="onFilterChange($event)"
    ></app-campos>
  </div>
</div>

@if(!!tableConfig){
  <app-insurance-table
  [data]="insuranceData"
  [config]="tableConfig!"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  [route]="route"
></app-insurance-table>
}
